export const isPostcode = string => {
  const regex = /^(0[289][0-9]{2})|([1-9][0-9]{3})$/gm;
  return regex.test(string);
}
